import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Container, Row, Col, Form, Table, Button, Modal, ButtonGroup, Badge, Tabs, Tab } from 'react-bootstrap';
import { BiDownload, BiListOl } from 'react-icons/bi';
import './RekamMedis.css';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import * as moment from 'moment';
import $ from 'jquery';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import LoadingSpinner from '../../shared/LoadingSpinner';
import { VedikaService } from '../../services/VedikaService';
import Laboratorium from './laboratorium/Laboratorium';
import Radiologi from './Radiologi/Radiologi';
import ResepElektronik from './ResepElektronik/ResepElektronik';
import Bedah from './bedah/Bedah';
import ResumeMedis from './resumemedis/ResumeMedis';
import Konsultasi from './konsultasi/Konsultasi';
import Diagnosis from './diagnosisi/Diagnosis';
import AsesmenGizi from './asesmengizi/AsesmenGizi';
import Documents from './document/Documents';
import Billings from './billing/Billings';
import SummaryList from './SummaryList/SummaryList';
import PemakaianVentilator from './PemakaianVentilator/PemakaianVentilator';
import Triase from './triase/Triase';

const RekamMedis = () => {
    const [listRuangan, setlistRuangan] = useState([]);
    const [selectedRuangan, setSelectedRuangan] = useState();
    const [isDataPasien, setisDataPasien] = useState();
    const [periodeAwal, setperiodeAwal] = useState();
    const [periodeAkhir, setperiodeAkhir] = useState();
    const [selectedData, setselectedData] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isLaboratorium, setisLaboratorium] = useState(true);
    const [isRadiologi, setisRadiologi] = useState(false);
    const [isBedah, setisBedah] = useState(false);
    const [isKonsultasi, setisKonsultasi] = useState(false);
    const [isDiagnosis, setisDiagnosis] = useState(false);
    const [isResepElektronik, setisResepElektronik] = useState(false);
    const [isAsesmenGizi, setisAsesmenGizi] = useState(false);
    const [isResumMedis, setisResumMedis] = useState(false);
    const [isBilling, setisBilling] = useState(false);
    const [isDocument, setisDocument] = useState(false);
    const [isSummaryList, setisSummaryList] = useState(false);
    const [isTriase , setsTriase ] = useState(false);
    const [ispemakaianventilator, setispemakaianventilator] = useState(false);
    const [isRm, setisRm] = useState(null);
    const [defaultTabs, setdefaultTabs] = useState(null);

    const [showPengkajianMedis, setshowPengkajianMedis] = useState();
    const handleClosePengkajianMedis = () => setshowPengkajianMedis(false);
    const handleShowPengkajianMedis = (row) => {
        loadApd(row)
        setshowPengkajianMedis(true);
    };
    const [showSep, setshowSep] = useState();
    const handleCloseSep = () => setshowSep(false);
    const handleShowSep = () => setshowSep(true);

    const loadInit = () => {
        setIsLoading(true)
        let tglAwal = moment(periodeAwal).format('YYYY-MM-DD HH:mm:ss');
        let tglAkhir = moment(periodeAkhir).format('YYYY-MM-DD HH:mm:ss');
        let param = '';
        // param += periodeAwal ? `tglAwal=${tglAwal}` : '';
        // param += periodeAkhir ? `&tglAkhir=${tglAkhir}` : '';
        // param += selectedRuangan ? `&ruangId=${selectedRuangan.id}` : '';
        // param += $('#noreg2').val() ? `&noreg=${$('#noreg2').val()}` : '';
        // param += $('#norm2').val() ? `&norm=${$('#norm2').val()}` : '';
        param += localStorage.getItem('rm') ? `norm=${localStorage.getItem('rm')}` : '';
        // param += $('#nama2').val() ? `&nama=${$('#nama2').val()}` : '';
        VedikaService.daftarAntrianVedika(param)
            .then((res) => {
                $('#dtList2').DataTable().clear().draw();
                return res;
            })
            .then((res) => {
                setisDataPasien(res.data)
                if (res.data.data.length > 0) {
                    loadDtList(res.data.data);
                }
            })
            .finally(() => {
                setIsLoading(false)
            })
            .catch((err) => {
                swal({
                    title: err.code,
                    text: err.message,
                    icon: "error",
                    button: "OK",
                })
                    .then((val) => {
                    });
            })
    }
    const handleChangeRuangan = (row) => {
        setSelectedRuangan(row)
    }

    const handleTabActive = (isTab) => {
        if (isTab == 'radiologi') { setisRadiologi(true) }
        if (isTab == 'bedah') { setisBedah(true) }
        if (isTab == 'konsultasi') { setisKonsultasi(true) }
        if (isTab == 'diagnosis') { setisDiagnosis(true) }
        if (isTab == 'resepelektronik') { setisResepElektronik(true) }
        if (isTab == 'asesmenGizi') { setisAsesmenGizi(true) }
        if (isTab == 'resumMedis') { setisResumMedis(true) }
        if (isTab == 'billings') { setisBilling(true) }
        if (isTab == 'documents') { setisDocument(true) }
        if (isTab == 'summaryList') { setisSummaryList(true) }
        if (isTab == 'pemakaianventilator') { setispemakaianventilator(true) }
        if (isTab == 'triase') { setsTriase(true) }
    }

    const loadApd = (row) => {
        setFalseTab()
        setIsLoading(true)
        VedikaService.getApd(row.norec_apd)
            .then((res) => {
                setselectedData(res.data.result);
            })
            .finally(() => {
                setdefaultTabs("laboratorium");
                setIsLoading(false)
            })
            .catch((err) => {
                swal({
                    title: err.code,
                    text: err.message,
                    icon: "error",
                    button: "OK",
                })
                    .then((val) => {
                    });
            })
    }
    const setFalseTab = () => {
        setisRadiologi(false);
        setisBedah(false);
        setisKonsultasi(false);
        setisDiagnosis(false);
        setisResepElektronik(false);
        setisAsesmenGizi(false);
        setisResumMedis(false);
        setisBilling(false);
        setisDocument(false);
        setisSummaryList(false);
        setispemakaianventilator(false);
    }
    const loadDtList = (res) => {
        $('#dtList2').DataTable({
            data: res,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            // scrollY: '50vh',
            destroy: true,
            autoWidth: false,
            columns: [
                {
                    targets: [0],
                    data: null,
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<ButtonGroup aria-label="Basic example"><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Pengkajian Medis' onClick={() => handleShowPengkajianMedis(rowData)}><BiListOl /></Button></ButtonGroup>),
                    width: '5%'
                },
                {
                    targets: [1],
                    data: 'tglregistrasi',
                    width: '11%'
                },
                {
                    targets: [2],
                    data: 'noregistrasi',
                    width: '8%'
                },
                {
                    targets: [3],
                    data: 'namadokter',
                    width: '15%'
                },
                {
                    targets: [4],
                    data: 'namaruanganawal',
                    width: '20%'
                },
                {
                    targets: [5],
                    data: 'namaruanganakhir',
                    width: '20%'
                },
                {
                    targets: [6],
                    data: 'nosep',
                    width: '12%'
                },
                {
                    targets: [6],
                    data: null,
                    width: '12%',
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<a href={`https://pelayanan.rsabhk.co.id/vedika/cetak/all/${rowData.norec_apd
                    }`} style={{textDecoration: 'none'}} target='_blank' download><Badge bg="success" style={{ fontSize: '0.9rem'}}>Download All <BiDownload/></Badge></a>),
                }
            ]
        })
    }

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '30px',
            height: '30px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '30px',
        }),
    };

    useEffect(() => {
        loadInit()
    }, [])

    useEffect(()=>{
        $('#norecPd').val(selectedData.norec_pd)
        $('#norec').val(selectedData.norec)
        $('#dpjp').val(selectedData.namalengkap)
    },[selectedData])

    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <ToastContainer />
            <Container fluid className='pb-5'>
                <Row>
                    <Col className='text-center bg-success text-white'>
                        <h5>Rekam Medis</h5>
                    </Col>
                </Row>
                <Row>
                    {
                        isDataPasien ? (
                            <>
                                <Col md={6} className='bg-warning'>
                                    <p style={{ margin: '0.7%' }}><strong>Nomor Rekam Medis:</strong>&nbsp;&nbsp;{isDataPasien.no_cm}</p>
                                </Col>
                                <Col md={6} className='bg-info'>
                                    <p style={{ margin: '0.7%' }}><strong>Nama Pasien:</strong>&nbsp;&nbsp;{isDataPasien.nama_pasien}</p>
                                </Col>
                            </>
                        ) : null
                    }
                </Row>
                <Row className='mt-2'>
                    <Col>
                        <Table responsive="sm" size="sm" id='dtList2' bordered hover style={{ fontSize: 'smaller' }}>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Tgl Registrasi</th>
                                    <th>No Registrasi</th>
                                    <th>DPJP</th>
                                    <th>Ruangan Awal</th>
                                    <th>Ruangan Akhir</th>
                                    <th>SEP</th>
                                    <th>Aksi</th>
                                </tr>
                            </thead>
                        </Table>
                    </Col>
                </Row>
                <Modal
                    show={showPengkajianMedis}
                    onHide={handleClosePengkajianMedis}
                    // backdrop="static"
                    fullscreen={true}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Pengkajian Medis</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col md={2}>
                                <Row>
                                    <Col sm={12}>
                                        <Form.Control type="text" id="norecPd" hidden/>
                                        <Form.Control type="text" id="norec" hidden/>
                                        <Form.Control type="text" id="umur" hidden />
                                        <Form.Control type="text" id="dpjp" hidden />
                                        <p className='f7'><strong>Nama</strong><br />{selectedData.namapasien}</p>
                                    </Col>
                                    <Col sm={12}>
                                        <p className='f7'><strong>No Rekam Medis</strong><br /><Badge bg="primary" id="nocm" style={{ fontSize: '0.9rem' }}>{selectedData.nocm}</Badge></p>
                                    </Col>
                                    <Col sm={12} className='pb-2'>
                                        <a href={`https://pelayanan.rsabhk.co.id/vedika/cetak/all/${selectedData.norec}`} style={{textDecoration: 'none'}} target='_blank' download><Badge bg="success" style={{ fontSize: '0.9rem'}}>Download All <BiDownload/></Badge></a>
                                    </Col>
                                    <Col sm={12}>
                                        <p className='f7'><strong>Jenis Kelamin</strong><br />{selectedData.jeniskelamin}</p>
                                    </Col>
                                    <Col sm={12}>
                                        <p className='f7'><strong>Tgl Lahir</strong><br />{selectedData.tgllahir}</p>
                                    </Col>
                                    <Col sm={12}>
                                        <p className='f7'><strong>Umur</strong><br />{selectedData.umur}</p>
                                    </Col>
                                    <Col sm={12}>
                                        <p className='f7'><strong>Alamat</strong><br />{selectedData.alamatlengkap}
                                        </p>
                                    </Col>
                                    <Col sm={12}>
                                        <p className='f7'><strong>No Registrasi</strong><br /><span id="noRegistrasi">{selectedData.noregistrasi}</span></p>
                                    </Col>
                                    <Col sm={12}>
                                        <p className='f7'><strong>Tanggal Registrasi</strong><br />{selectedData.tglregistrasi}</p>
                                    </Col>
                                    <Col sm={12}>
                                        <p className='f7'><strong>Kelompok Pasien</strong><br />{selectedData.kelompokpasien}</p>
                                    </Col>
                                    <Col sm={12}>
                                        <p className='f7'><strong>Kelas</strong><br />{selectedData.namakelas}</p>
                                    </Col>
                                    <Col sm={12}>
                                        <p className='f7'><strong>Ruangan</strong><br />{selectedData.namaruangan}</p>
                                    </Col>
                                    <Col sm={12}>
                                        <p className='f7'><strong>Tanggal Pulang</strong><br />{selectedData.tglpulang}</p>
                                    </Col>
                                    <Col sm={12}>
                                        <p className='f7'><strong>Ruangan Akhir</strong><br />{selectedData.namaruanganakhir}</p>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={10} >
                                {
                                    defaultTabs ? 
                                
                                <Tabs
                                    defaultActiveKey={defaultTabs}
                                    id="uncontrolled-tab-example"
                                    fill
                                    onSelect={(index) => handleTabActive(index)}
                                >
                                    <Tab eventKey="laboratorium" title="Laboratorium">
                                        {
                                            isLaboratorium ? <Laboratorium /> : null
                                        }
                                    </Tab>
                                    <Tab eventKey="radiologi" title="Radiologi">
                                        {
                                            isRadiologi ? <Radiologi /> : null
                                        }
                                    </Tab>
                                    <Tab eventKey="bedah" title="Bedah">
                                        {
                                            isBedah ? <Bedah /> : null
                                        }
                                    </Tab>
                                    <Tab eventKey="konsultasi" title="Konsultasi">
                                        {
                                            isKonsultasi ? <Konsultasi /> : null
                                        }
                                    </Tab>
                                    {/* <Tab eventKey="pengkajianAwal" title="Pengkajian Awal">
                                            <PengkajianAwal/>
                                        </Tab>
                                        <Tab eventKey="pengkajianKeperawatan" title="Pengkajian Keperawatan">
                                            <PengkajianKeperawatan/>
                                        </Tab>
                                        <Tab eventKey="cppt" title="CPPT/TBAK/Pengkajian Awal">
                                            <Cppt/>
                                        </Tab> */}
                                    <Tab eventKey="diagnosis" title="Diagnosis">

                                        {
                                            isDiagnosis ? <Diagnosis /> : null
                                        }
                                    </Tab>
                                    <Tab eventKey="resepelektronik" title="Resep Elektronik">
                                        {
                                            isResepElektronik ? <ResepElektronik /> : null
                                        }
                                    </Tab>
                                    <Tab eventKey="asesmenGizi" title="Asesmen Gizi">
                                        {
                                            isAsesmenGizi ? <AsesmenGizi /> : null
                                        }
                                    </Tab>
                                    <Tab eventKey="summaryList" title="Summary List">
                                        {
                                            isSummaryList ? <SummaryList /> : null
                                        }
                                    </Tab>
                                    <Tab eventKey="resumMedis" title="Resume Medis">

                                        {
                                            isResumMedis ? <ResumeMedis /> : null
                                        }
                                    </Tab>
                                    <Tab eventKey="billings" title="Billing">
                                        {
                                            isBilling ? <Billings /> : null
                                        }
                                    </Tab>
                                    <Tab eventKey="pemakaianventilator" title="Riwayat Pemakaian Ventilator">
                                        {
                                            ispemakaianventilator ? <PemakaianVentilator /> : null
                                        }
                                    </Tab>
                                    <Tab eventKey="triase" title="Triase">
                                        {
                                            isTriase ? <Triase /> : null
                                        }
                                    </Tab>
                                    <Tab eventKey="documents" title="Document">
                                        {
                                            isDocument ? <Documents /> : null
                                        }
                                    </Tab>
                                </Tabs> : null
                                }
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
                <Modal
                    show={showSep}
                    onHide={handleCloseSep}
                    backdrop="static"
                    size='xl'
                >
                    <Modal.Header closeButton>
                        <Modal.Title>SEP</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>

                        </Row>
                    </Modal.Body>
                </Modal>
            </Container>
        </React.Fragment>
    )
}
export default RekamMedis;